import React from 'react';
import './pagefooter.css';
import { Helmet } from "react-helmet-async";

const AppPrivacy = () => (
  <>
    <Helmet>
      <title>Privacy Policy | AIKYAM Sports Science</title>

      <meta
        name="description"
        content="Read the AIKYAM Sports Science Privacy Policy. Learn how we collect, use, protect, and manage your personal information, athlete performance data, and account information."
      />

      <meta
        name="keywords"
        content="AIKYAM Privacy Policy, Athlete Data Privacy, Sports App Privacy Policy, AIKYAM Sports Science Privacy"
      />

      <link
        rel="canonical"
        href="https://aikyamsports.com/app-privacy"
      />

      {/* Open Graph */}
      <meta
        property="og:title"
        content="Privacy Policy | AIKYAM Sports Science"
      />

      <meta
        property="og:description"
        content="Learn how AIKYAM Sports Science collects, uses, stores, and protects your personal information and athlete performance data."
      />

      <meta
        property="og:url"
        content="https://aikyamsports.com/app-privacy"
      />

      <meta
        property="og:type"
        content="website"
      />

      <meta
        property="og:image"
        content="https://aikyamsports.com/logo11.png"
      />

      {/* Twitter */}
      <meta
        name="twitter:card"
        content="summary_large_image"
      />

      <meta
        name="twitter:title"
        content="Privacy Policy | AIKYAM Sports Science"
      />

      <meta
        name="twitter:description"
        content="Read the AIKYAM Sports Science Privacy Policy for information on data collection, security, and account deletion."
      />

      <meta
        name="twitter:image"
        content="https://aikyamsports.com/logo11.png"
      />
    </Helmet>
  <div className="policy-page">
    <h1>Privacy Policy</h1>

<p>
  Aikyam Sports Science is committed to protecting your privacy.
  This Privacy Policy explains how we collect, use, store, and
  protect your personal information when you use our website,
  mobile application, and services.
</p>

<ul>
  <li>
    <strong>Information Collection:</strong> We may collect personal
    information such as your name, email address and sports performance data when you use our
    services or products.
  </li>

  <li>
    <strong>Use of Information:</strong> Your information is used to
    provide and improve our services, manage your account, process
    requests, analyze performance data, and communicate with you.
  </li>

  <li>
    <strong>Data Security:</strong> We implement industry-standard
    security measures to protect your information from unauthorized
    access, disclosure, alteration, or destruction.
  </li>

  <li>
    <strong>Information Sharing:</strong> We do not sell your
    personal information. Information may only be shared when
    required by law or when necessary to provide our services.
  </li>

  <li>
    <strong>Data Retention:</strong> We retain user data only while
    an account remains active and as necessary to provide our
    services.
  </li>

  <li>
    <strong>Account and Data Deletion:</strong> Users can delete
    their account directly within the application by navigating to
    <strong> Settings → Delete Account</strong>. When an account is
    deleted, the associated personal data is permanently removed
    from our systems immediately, except where retention is required
    by applicable law.
  </li>

  <li>
    <strong>Contact:</strong> For privacy-related questions or data
    deletion requests, contact us at:
    +91 6363202281
  </li>
</ul>

  </div>
  </>
);

export default AppPrivacy;
